import { StandardEvents } from '@shopify/events';
import { DrawerOpenEvent, DrawerCloseEvent } from '@theme/theme-drawer';

class NuvipilHeaderCart extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate, { signal });
    document.addEventListener(DrawerOpenEvent.eventName, this.syncDrawer, { signal });
    document.addEventListener(DrawerCloseEvent.eventName, this.syncDrawer, { signal });
    this.addEventListener('click', this.onCartClick, { signal });
    this.syncDrawer();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  onCartUpdate = (event) => {
    event.promise?.then(({ cart, detail }) => {
      if (detail?.didError || !Number.isInteger(cart?.totalQuantity)) return;
      const count = cart.totalQuantity;
      this.querySelectorAll('[data-nuvipil-cart-count]').forEach((node) => {
        node.textContent = String(count);
        if (node.hasAttribute('data-cart-badge')) node.hidden = count === 0;
      });
      this.querySelectorAll('[data-nuvipil-cart]').forEach((link) => {
        link.setAttribute('aria-label', link.dataset.cartLabel.replace('__count__', String(count)));
      });
      const status = this.querySelector('[data-cart-live]');
      if (status) status.textContent = status.dataset.message.replace('__count__', String(count));
    }).catch(() => {});
  };

  syncDrawer = () => {
    const drawer = document.getElementById('cart-drawer');
    this.querySelectorAll('[data-nuvipil-cart]').forEach((link) => {
      if (!drawer) {
        link.removeAttribute('aria-controls');
        link.removeAttribute('aria-expanded');
        link.removeAttribute('aria-haspopup');
        return;
      }
      link.setAttribute('aria-controls', 'cart-drawer');
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-expanded', drawer.hasAttribute('open') ? 'true' : 'false');
    });
  };

  onCartClick = (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('[data-nuvipil-cart]');
    if (!link || !this.contains(link)) return;
    const drawer = document.getElementById('cart-drawer');
    if (typeof drawer?.open !== 'function') return;
    event.preventDefault();
    const menu = link.closest('details');
    if (menu) menu.open = false;
    drawer.open();
  };
}

if (!customElements.get('nuvipil-header-cart')) {
  customElements.define('nuvipil-header-cart', NuvipilHeaderCart);
}
